import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import DeleteIcon from "@mui/icons-material/Delete";

import { productsItems } from "../apis/productsApiSlice";
import { deleteItem, updateItem, cartsItems } from "../apis/cartsApiSlice";

const Cart = () => {
  const products = useSelector(productsItems);
  const carts = useSelector(cartsItems);

  const dispatch = useDispatch();

  const [cartItems, setCartItems] = useState([]);

  useEffect(() => {
    setCartItems(carts ?? []);
  }, [carts]);

  if (products?.length) {
    let total = 0;
    let delivery = 25;
    const eachCart = (productId, quantity) => {
      let product = products.filter((item) => {
        if (parseInt(item.id) === parseInt(productId)) {
          total = (
            parseFloat(total) +
            parseFloat(item.price) * parseInt(quantity)
          ).toFixed(2);
          return item;
        }
      });

      if (product?.length) {
        product = product[0];
      }

      return (
        <div
          key={product.id}
          className="flex gap-4 sm:gap-8 sm:w-[calc(50%-8px)] items-start w-full p-4 shadow-lg"
        >
          <div className="flex items-center justify-center min-w-[50px]">
            <img
              className="w-[50px] sm:w-[100px] h-auto"
              src={product.image}
              alt={product.title}
            />
          </div>
          <div className="flex flex-grow flex-col">
            <h4 className="text-base mb-2">{product.title}</h4>
            <p className="text-sm text-end">
              {product.price.toFixed(2)} x {quantity}
            </p>
            <p className="text-lg text-end mb-6">
              $ {(parseFloat(product.price) * parseInt(quantity)).toFixed(2)}
            </p>
            <div className="flex justify-between mt-auto mb-0">
              <div className="flex gap-4 text-primary">
                <RemoveCircleOutlineIcon
                  className="cursor-pointer"
                  onClick={() => {
                    dispatch(
                      updateItem({ product: product.id, type: "minus" })
                    );
                  }}
                />
                {quantity}
                <AddCircleOutlineIcon
                  className="cursor-pointer"
                  onClick={() => {
                    dispatch(updateItem({ product: product.id, type: "plus" }));
                  }}
                />
              </div>
              <button
                className="text-error"
                onClick={() => {
                  dispatch(deleteItem(product.id));
                }}
              >
                <DeleteIcon />
              </button>
            </div>
          </div>
        </div>
      );
    };

    return (
      <section>
        <div className="mb-4">
          <h3 className="text-4xl">Cart</h3>
        </div>
        <div className="flex flex-wrap gap-4 max-h-[calc(100vh-410px)] py-4 overflow-y-auto">
          {cartItems?.length
            ? cartItems.map((item) => eachCart(item.productId, item.quantity))
            : "No items.!"}
        </div>
        <div className="flex flex-wrap items-center pt-[50px]">
          <h4 className="text-xl w-full">Summary</h4>
          <div className="w-1/2 sm:w-4/5">Total</div>
          <div className="w-1/2 sm:w-1/5 text-end">$ {total}</div>
          <div className="w-1/2 sm:w-4/5">Delivery charges</div>
          <div className="w-1/2 sm:w-1/5 text-end">$ {delivery.toFixed(2)}</div>
          <div className="w-1/2 sm:w-4/5">Grand total</div>
          <div className="w-1/2 sm:w-1/5 text-xl text-end border-t-[1px] border-b-[4px] border-double">
            $ {(parseFloat(total) + parseInt(delivery)).toFixed(2)}
          </div>
        </div>
      </section>
    );
  }
};

export default Cart;
